// @ts-strict-ignore
import {
  AgriculturalLandList,
  AnimalDigestionList,
  CementAndConcreteList,
  ChemicalList,
  ElectricityAndDistrictHeatingList,
  FossileFreeFreightTransportList,
  FossileFreeTransportsByCarList,
  IndustryOtherList,
  IronAndSteelList,
  LocalCoolingList,
  LocalCoolingResidentialList,
  LocalHeatingList,
  LocalHeatingResidentialList,
  LocalOtherList,
  LocalOtherResidentialList,
  MachineryList,
  MetalsList,
  OtherTransportList,
  PaperAndPulpList,
  RefineriesList,
  SolventsList,
  StorageOfFertilisersList,
  TransitionElement,
  WasteList,
} from '../../model/enums/transition-element';
import { TransitionTargetSubsector } from '../../model/enums/transition-target-subsector';

export function getSubsectorForTransitionElement(transitionElement: TransitionElement): TransitionTargetSubsector {
  const te = transitionElement as any;
  if (FossileFreeTransportsByCarList.includes(te)) {
    return TransitionTargetSubsector.Mobility;
  } else if (FossileFreeFreightTransportList.includes(te)) {
    return TransitionTargetSubsector.Freight;
  } else if (OtherTransportList.includes(te)) {
    return TransitionTargetSubsector.OtherTransport;
  } else if (IronAndSteelList.includes(te)) {
    return TransitionTargetSubsector.IronAndSteel;
  } else if (CementAndConcreteList.includes(te)) {
    return TransitionTargetSubsector.CementAndConcrete;
  } else if (RefineriesList.includes(te)) {
    return TransitionTargetSubsector.Refineries;
  } else if (ChemicalList.includes(te)) {
    return TransitionTargetSubsector.Chemical;
  } else if (PaperAndPulpList.includes(te)) {
    return TransitionTargetSubsector.PaperAndPulp;
  } else if (MetalsList.includes(te)) {
    return TransitionTargetSubsector.Metals;
  } else if (IndustryOtherList.includes(te)) {
    return TransitionTargetSubsector.IndustryOther;
  } else if (AgriculturalLandList.includes(te)) {
    return TransitionTargetSubsector.AgriculturalLand;
  } else if (AnimalDigestionList.includes(te)) {
    return TransitionTargetSubsector.AnimalDigestion;
  } else if (StorageOfFertilisersList.includes(te)) {
    return TransitionTargetSubsector.StorageOfFertilisers;
  } else if (ElectricityAndDistrictHeatingList.includes(te)) {
    return TransitionTargetSubsector.ElectricityAndDistrictHeating;
  } else if (LocalHeatingList.includes(te)) {
    return TransitionTargetSubsector.LocalHeating;
  } else if (LocalHeatingResidentialList.includes(te)) {
    return TransitionTargetSubsector.LocalHeatingResidential;
  } else if (LocalCoolingResidentialList.includes(te)) {
    return TransitionTargetSubsector.LocalCoolingResidential;
  } else if (LocalCoolingList.includes(te)) {
    return TransitionTargetSubsector.LocalCooling;
  } else if (LocalOtherList.includes(te)) {
    return TransitionTargetSubsector.LocalOther;
  } else if (LocalOtherResidentialList.includes(te)) {
    return TransitionTargetSubsector.LocalOtherResidential;
  } else if (SolventsList.includes(te)) {
    return TransitionTargetSubsector.Solvents;
  } else if (MachineryList.includes(te)) {
    return TransitionTargetSubsector.Machinery;
  } else if (WasteList.includes(te)) {
    return TransitionTargetSubsector.Waste;
  }
  return undefined;
}
